/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionDraftFormData
 */
export interface PalAuthSubmissionDraftFormData {
    /**
     * 
     */
    form_id: string;
    /**
     * 
     */
    values: { [key: string]: any; };
    /**
     * 
     */
    saved_at: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionDraftFormData interface.
 */
export function instanceOfPalAuthSubmissionDraftFormData(value: object): value is PalAuthSubmissionDraftFormData {
    if (!('form_id' in value) || value['form_id'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('saved_at' in value) || value['saved_at'] === undefined) return false;
    return true;
}

export function PalAuthSubmissionDraftFormDataFromJSON(json: any): PalAuthSubmissionDraftFormData {
    return PalAuthSubmissionDraftFormDataFromJSONTyped(json, false);
}

export function PalAuthSubmissionDraftFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionDraftFormData {
    if (json == null) {
        return json;
    }
    return {
        
        'form_id': json['form_id'],
        'values': json['values'],
        'saved_at': json['saved_at'],
    };
}

export function PalAuthSubmissionDraftFormDataToJSON(json: any): PalAuthSubmissionDraftFormData {
    return PalAuthSubmissionDraftFormDataToJSONTyped(json, false);
}

export function PalAuthSubmissionDraftFormDataToJSONTyped(value?: PalAuthSubmissionDraftFormData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form_id': value['form_id'],
        'values': value['values'],
        'saved_at': value['saved_at'],
    };
}

